export const drawingMaterialsMcsData = (data) => {
  return data.map((row) => {
    const revs = row.drawingRevs || [];
    const sortedRevs = revs.sort((a, b) => a.revision - b.revision) || [];
    const drawing = row.drawing || {};
    const tagNumber = row.taggedMaterial?.tagNumber;
    const item = row.item;

    const index = sortedRevs.findIndex((rev) => rev.id === drawing?.id);
    const notRev0 = index > 0;

    const previousDrawing = index !== 0 ? sortedRevs[index - 1] : {};
    const previousMaterial = previousDrawing?.materials?.find(
      (pm) =>
        (pm.taggedMaterial?.tagNumber || pm.item) ===
        (row.taggedMaterial?.tagNumber || row.item),
    );

    let hasChanged = false;
    ["description", "quantity", "length"].forEach((key) => {
      if (previousMaterial && row[key] !== previousMaterial[key]) {
        hasChanged = true;
      }
    });

    //////////////////////////// MRQ Logic ////////////////////////////
    let mrqChips =
      row.mrqMaterials?.map((m) => {
        return m?.mrq;
      }) || [];

    // If no current MRQ, check for inherited MRQ from previous revisions
    if (!mrqChips?.[0] && notRev0) {
      const latestMrq = findLatestRevisionWithData(
        sortedRevs,
        index,
        tagNumber || item,
        row,
        (material) => material?.mrqMaterials?.map((m) => m?.mrq) || null,
      );
      if (latestMrq) {
        mrqChips = latestMrq;
      }
    }

    const hasPreviousMrq =
      previousDrawing?.id && previousMaterial?.mrqMaterials?.[0]?.id
        ? true
        : false;

    //////////////////////////// PO Logic ////////////////////////////

    let poChips = [];

    row.mrqMaterials?.forEach((m) => {
      m.poMaterials?.forEach((pm) => poChips.push(pm.po));
    });

    // If no current PO, check for inherited PO from previous revisions
    if (!poChips?.[0] && notRev0) {
      const latestPo = findLatestRevisionWithData(
        sortedRevs,
        index,
        tagNumber || item,
        row,
        (material) => {
          const pos = [];
          material?.mrqMaterials?.forEach((m) => {
            m.poMaterials?.forEach((pm) => pos.push(pm.po));
          });
          return pos.length > 0 ? pos : null;
        },
      );
      if (latestPo) {
        poChips = latestPo;
      }
    }

    const hasPreviousPo =
      previousDrawing?.id &&
      previousMaterial?.mrqMaterials?.[0]?.poMaterials?.[0]?.id
        ? true
        : false;

    const previousPO = {
      ...previousMaterial?.mrqMaterials?.[0]?.poMaterials?.[0]?.po,
    };

    //////////////////////////// Vendor Logic ////////////////////////////
    let vendor = row.mrqMaterials?.[0]?.poMaterials?.[0]?.vendor?.name || "";
    let cost = row.mrqMaterials?.[0]?.poMaterials?.[0]?.cost || "";
    let date = row.mrqMaterials?.[0]?.poMaterials?.[0]?.time;

    if (!vendor) {
      if (index > 0) {
        const latestVendor = findLatestRevisionWithData(
          sortedRevs,
          index,
          tagNumber || item,
          row,
          (material) =>
            material?.mrqMaterials?.[0]?.poMaterials?.[0]?.vendor?.name || null,
        );
        if (latestVendor) {
          vendor = latestVendor;
        }
      }
    }
    if (!cost) {
      if (index > 0) {
        const latestCost = findLatestRevisionWithData(
          sortedRevs,
          index,
          tagNumber || item,
          row,
          (material) =>
            material?.mrqMaterials?.[0]?.poMaterials?.[0]?.cost || null,
        );
        if (latestCost) {
          cost = latestCost;
        }
      }
    }
    if (!date) {
      if (index > 0) {
        const latestDate = findLatestRevisionWithData(
          sortedRevs,
          index,
          tagNumber || item,
          row,
          (material) =>
            material?.mrqMaterials?.[0]?.poMaterials?.[0]?.time || null,
        );
        if (latestDate) {
          date = latestDate;
        }
      }
    }

    //////////////////////////// MRV Logic ////////////////////////////

    let mrvChips =
      row.mrvMaterials?.map((m) => {
        return m.mrv;
      }) || [];

    // If no current MRV, check for inherited MRV from previous revisions
    if (!mrvChips?.[0] && notRev0 && !hasChanged) {
      const latestMrv = findLatestRevisionWithData(
        sortedRevs,
        index,
        tagNumber || item,
        row,
        (material) => material?.mrvMaterials?.map((m) => m.mrv) || null,
      );
      if (latestMrv) {
        mrvChips = latestMrv;
      }
    }

    //////////////////////////// SRV Logic ////////////////////////////
    let srvChips =
      row.srvMaterials?.map((m) => {
        return m.srv;
      }) || [];

    // If no current sRV, check for inherited sRV from previous revisions
    if (!srvChips?.[0] && notRev0 && !hasChanged) {
      const latestSrv = findLatestRevisionWithData(
        sortedRevs,
        index,
        tagNumber || item,
        row,
        (material) => material?.srvMaterials?.map((m) => m.srv) || null,
      );
      if (latestSrv) {
        srvChips = latestSrv;
      }
    }

    //////////////////////////// hEAT # Logic ////////////////////////////
    let heatNumber = row.heatNumber || "";

    if (!heatNumber) {
      if (index > 0) {
        const latestHeat = findLatestRevisionWithData(
          sortedRevs,
          index,
          tagNumber || item,
          row,
          (material) => material?.mrqMaterials?.[0]?.heatNumber || null,
        );
        if (latestHeat) {
          heatNumber = latestHeat;
        }
      }
    }

    ////////////////////////////  Logic ////////////////////////////

    // item == 3 && console.log("ddddd3", notRev0, previousMaterial, row);

    return {
      ...row,
      hasChanged,
      notRev0,
      drawing,
      previousDrawing,

      mrqChips,
      hasPreviousMrq,
      poChips,
      hasPreviousPo,
      previousPO,
      vendor: poChips?.[0] && !hasChanged ? vendor : "",
      cost: poChips?.[0] && !hasChanged ? cost : "",
      schedule: poChips?.[0] && !hasChanged ? date : "",

      mrvChips,
      srvChips,
      heatNumber,
    };
  });
};

// Helper function to find the latest revision with data for unchanged material
const findLatestRevisionWithData = (
  revisions,
  currentIndex,
  tagNumber,
  currentMaterial,
  dataAccessor,
) => {
  const sortedRevs = revisions.sort((a, b) => a.revision - b.revision);

  let hasChanged = false;
  ["description", "length", "quantity"].forEach((key) => {
    if (currentMaterial[key]) {
      // Check if description changed from any previous revision
      for (let i = currentIndex - 1; i >= 0; i--) {
        const prevMaterial = sortedRevs[i]?.materials?.find(
          (pm) => (pm.taggedMaterial?.tagNumber || pm.item) === tagNumber,
        );
        if (prevMaterial && currentMaterial[key] !== prevMaterial[key]) {
          hasChanged = true;
          break;
        }
      }
    }
  });

  // If material hasn't changed, find the latest revision with the data
  if (!hasChanged) {
    for (let i = currentIndex - 1; i >= 0; i--) {
      const material = sortedRevs[i]?.materials?.find(
        (pm) => (pm.taggedMaterial?.tagNumber || pm.item) === tagNumber,
      );
      if (material) {
        const data = dataAccessor(material);
        if (data) {
          return data;
        }
      }
    }
  }

  return null;
};
